import React, { useEffect, useMemo } from 'react'
import { useRouteMatch, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Breadcrumb } from 'react-breadcrumbs'

import CityPage from 'Containers/City/Page'
import { getInventoryItem } from 'Reducers/Inventory/actions'
import { PageWrapper } from 'Components/Layout/Page/PageWrapper'
import { filterMovementsByCity } from 'Utils/Inventory'

import InventoryMovements from './components/InventoryMovements'

const Movements = ({ cityName }) => {
  const { cityId, inventoryId } = useParams()
  const match = useRouteMatch()
  const dispatch = useDispatch()
  const { movements, inventoryItems, ambassadors, cities } = useSelector(
    state => ({
      movements: state.inventory.movements,
      inventoryItems: state.inventory.inventoryItems,
      ambassadors: state.ambassadors.ambassadors,
      cities: state.city.cities,
    }),
  )

  useEffect(() => {
    dispatch(getInventoryItem(inventoryId))
  }, [inventoryId])

  const { movement, tag } = useMemo(() => {
    if (
      inventoryItems &&
      inventoryItems[inventoryId] &&
      movements &&
      movements[inventoryId]
    ) {
      return {
        tag: inventoryItems[inventoryId].tag,
        movement: movements[inventoryId].map(m => {
          var newObj = {
            ...m,
          }
          if (m.relatedUserId) {
            var user = ambassadors[m.relatedUserId]
            var city = cities[m.relatedCityId]

            if (user) {
              newObj.relatedUserName = user.firstName + ' ' + user.lastName
            }
            if (city) {
              newObj.relatedCityName = city.name
            }
          }
          return newObj
        }),
      }
    } else {
      return {}
    }
  }, [movements, inventoryItems, inventoryId, ambassadors, cities])

  return (
    <CityPage cityId={cityId} cityName={cityName}>
      <Breadcrumb data={{ title: 'Inventory', pathname: match.url }} />

      <PageWrapper>
        <InventoryMovements
          cityId={cityId}
          tag={tag}
          movements={filterMovementsByCity(movement, cityId)}
        />
      </PageWrapper>
    </CityPage>
  )
}

export default Movements



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Movements/index.js